export const githubUsername = "Adam-Musial-AMu";
